import styled from 'styled-components'

export const MedicalRecordContainer = styled.div``

export const Header = styled.div`
  p:last-child {
    color: #898989;
  }
`

export const BoxInfo = styled.ul`
  background-color: #fffcb5;

  margin: 20px 0 30px;
  padding: 15px 20px;

  border-radius: 10px;

  li {
    display: flex;
    gap: 10px;

    span {
      display: flex;
      flex: none;
      align-items: center;
      justify-content: center;

      width: 24px;
      height: 24px;

      border-radius: 12px;

      background-color: #1f35b5;
      color: #fff;
    }
  }

  li + li {
    margin-top: 20px;
  }
`

export const Form = styled.div`
  width: 100%;
  padding-top: 0;
  margin-top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 50px;
`

export const Footer = styled.div`
  margin-top: 40px;

  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ButtonsWrapper = styled.div`
  button {
    width: 100%;
  }

  button + button {
    margin-top: 20px;
  }
`

export const HelperButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  width: 25px;
  height: 25px;

  > svg {
    fill: #000000;
  }
`

export const AutoFillDeclarationCheckbox = styled.label<{ checked: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 24px 20px;

  border: 1px ${({ checked }) => (checked ? 'solid #BDBDBD' : 'dashed #BDBDBD')};
  border-radius: 20px;

  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    border: 1px ${({ checked }) => (checked ? 'solid #BDBDBD' : 'dashed #BDBDBD')};
  }

  input {
    display: none;
  }
`

export const CheckboxIcon = styled.div<{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: ${({ checked }) => (checked ? '28px' : '24px')};
  height: ${({ checked }) => (checked ? '28px' : '24px')};
  margin-right: ${({ checked }) => (checked ? '0' : '4px')};

  border: ${({ checked }) => (checked ? 'none' : '2px solid #757575')};
  border-radius: 50%;

  transition: transform 0.3s ease;
  transform: ${({ checked }) => (checked ? 'rotateY(180deg)' : 'rotateY(0deg)')};

  svg {
    width: 32px;
    height: 32px;
    transform: rotateY(180deg);
  }
`